<template>
  <div class="step-question-template medical-step-question">
    <div class="question-text">{{ question.anyMedicineQuestion }}</div>
    <YesNo v-model="isTakingAnyMedicine" :yes="true" :no="false" :id="'any-' + question.id" />

    <div class="question-error" v-if="anyErrorMessage">
      {{ anyErrorMessage }}
    </div>

    <div v-if="isTakingAnyMedicine">
      <div class="question-text" style="margin-top: 60px" v-html="question.contraindicationQuestion"></div>
      <div class="question-text">
        <ul class="question-points">
          <li v-for="(point, idx) in question.contraindications" :key="idx">
            <span v-html="point"></span>
          </li>
        </ul>
      </div>
      <YesNo v-model="isTakingContraindicated" :yes="true" :no="false" :id="'contraindicated-' + question.id" />

      <div class="question-error" v-if="errorMessage">{{ errorMessage }}</div>

      <div class="question-text" style="margin-top: 60px">
        {{ question.otherMedicinesTakenQuestion }}
      </div>
      <textarea
        class="question-additional-notes"
        placeholder="Include the medication name, strength and how often you take it for each medication you are taking..."
        v-model="otherMedicinesTaken"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import poster from "../mixins/poster";
import validator from "../mixins/validator";
import responseAdapters from "../mixins/responseAdapters";
import YesNo from "./YesNo.vue";

export default Vue.extend({
  mixins: [poster, validator],
  inject: ["isUs", "submitUrl", "csrfHeader", "csrf"],
  components: {
    YesNo,
  },
  props: {
    question: { required: true },
    showRequired: { required: true },
    first: { required: true },
    validate: { required: false, default: true },
  },
  data() {
    return {
      isTakingAnyMedicine: this.question.isTakingAnyMedicine,
      isTakingContraindicated: this.question.isTakingContraindicated,
      otherMedicinesTaken: this.question.otherMedicinesTaken,
      responseAdapter: responseAdapters.freeTextMedical,
    };
  },
  created() {
    this.$emit("answer", this.question, this.responseAdapter(this.question));
    if ((this.isTakingAnyMedicine && this.isTakingContraindicated != null) || this.isTakingAnyMedicine == false) {
      this.hasDefaultAnswer = true;
      this.updateNextButtonStatus(true, this.isTakingAnyMedicine === true && this.isTakingContraindicated);
    }
  },
  computed: {
    errorMessage() {
      if (this.validate && this.valid === false) {
        return this.question.rejectMessage;
      }

      if (this.showRequired && this.isTakingContraindicated === null) {
        return "You must answer the question to continue";
      }

      if (
        this.showRequired &&
        this.hasFilledInAnyAndContraindicated &&
        this.isTakingAnyMedicine &&
        !this.hasContraindicatedOrOtherMedicinesTaken
      ) {
        return "Please list below the other medications you’re taking";
      }

      return null;
    },
    anyErrorMessage() {
      if (this.showRequired && this.isTakingAnyMedicine === null) {
        return "You must answer the question to continue";
      }

      return null;
    },
    valid() {
      if (this.isTakingAnyMedicine === null) {
        return null;
      }
      if (this.isTakingAnyMedicine) {
        if (this.isTakingContraindicated === null) {
          return null;
        }

        if (!this.hasContraindicatedOrOtherMedicinesTaken) {
          return null;
        }

        if (this.validate && this.isTakingContraindicated) {
          return false;
        }
      }

      return true;
    },
    hasFilledInAnyAndContraindicated() {
      return this.isTakingAnyMedicine != null && this.isTakingContraindicated != null;
    },
    hasContraindicatedOrOtherMedicinesTaken() {
      return this.isTakingContraindicated || (this.otherMedicinesTaken !== null && this.otherMedicinesTaken.length > 0);
    },
  },
  watch: {
    isTakingAnyMedicine(newValue) {
      this.question.isTakingAnyMedicine = newValue;
      if (newValue === false) {
        this.isTakingContraindicated = null;
      }

      this.$emit("any-input-changed", newValue);
      this.save();

      if (this.isUs) {
        if (newValue === false && !this.hasDefaultAnswer) {
          this.question.isTakingContraindicated = false;
          this.$emit("next");
        } else {
          this.updateNextButtonStatus(true, false);
        }
      }
    },
    isTakingContraindicated(newValue) {
      if (this.isUs && (newValue !== null || this.question.isTakingContraindicated === true)) {
        this.updateNextButtonStatus(true, newValue);
      }
      this.question.isTakingContraindicated = newValue;
      this.save();
    },
    otherMedicinesTaken(newValue) {
      this.question.otherMedicinesTaken = newValue;
      this.save();
    },
  },
  methods: {
    save() {
      this.post(this.responseAdapter(this.question));
    },
    updateNextButtonStatus(show, inErrorState) {
      this.$emit("update-next-button-status", show, inErrorState);
    },
  },
});
</script>
